import React, { useState, useEffect ,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowLeft from './images/ArrowLeft.png';
import Search from './images/Search.png';
import ProductSearchOverlay from './Component/ProductSearchoverlay';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import ViewBucket from './Component/ViewBucket';
import Header1 from './Component/Header1';
import defaultimg from "./images/defaultimg.png";

const ProductCategories = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isProductSearchOpen, setIsProductSearchOpen] = useState(false);
  const [bucketProducts, setBucketProducts] = useState({});
  const [showViewBucket, setShowViewBucket] = useState(false);
  const bucketRef = useRef(null);

  
  

  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${fetchUrl}product-category/get-all-productCategories?is_ecommerce=true`,
        { method: "GET", 
          headers: { 
            "Content-Type": "application/json",
            "x-token": token
           } }
      );
      const data = await response.json();
      if (data.success) setCategories(data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
  const fetchBucketProducts = () => {
    const savedBucketProducts = localStorage.getItem("bucketProducts");
    if (savedBucketProducts) {
      const products = JSON.parse(savedBucketProducts);
      setBucketProducts(products);
      setShowViewBucket(Object.keys(products).length > 0);
    } else {
      setBucketProducts({});
      setShowViewBucket(false);
    }
  };

  fetchBucketProducts();

  if (!isProductSearchOpen) {
    fetchBucketProducts();
  }
}, [isProductSearchOpen]);


  const handleCategoryClick = (category) => {
    navigate("/consumer/productlist", {
      state: {
        categoryId: category._id,
        categoryName: category.product_category_name,
      },
    });
  };

  if (loading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-50 z-50">
        <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-400 text-xs">Loading Categories...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <Header1
  title="Categories"
  showSearch={true}
  onSearchClick={() => setIsProductSearchOpen(true)}
  backPath="/consumer/projectdetails"

/>

      {/* Categories List */}
      <div className="flex-1 overflow-y-auto">
        <div className="px-4 py-3">
          {categories.length > 0 ? (
            categories.map((category) => (
              <div
                key={category._id}
                onClick={() => handleCategoryClick(category)}
                className="flex items-center bg-white rounded-2xl p-3 mb-3 shadow-sm hover:shadow-md transition cursor-pointer"
              >
                {/* Image */}
                <div className="w-16 h-16 flex items-center justify-center overflow-hidden flex-shrink-0">
  <img
    src={
      category.product_category_image
        ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${category.product_category_image}`
        : defaultimg
    }
    alt={category.product_category_name}
     className={`h-14 w-14 object-cover mb-2 rounded-md ${
    category.product_category_image ? "" : "bg-gray-100"
  }`}
    onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = defaultimg;
    }}
  />
</div>

                {/* Text */}
                <div className="ml-3 flex-1">
                  <h3 className="text-sm font-semibold text-gray-900">
                    {category.product_category_name}
                  </h3>
                  {category.product_category_description && (
                    <p
                      className="text-xs text-gray-500 mt-1 line-clamp-2"
                      title={category.product_category_description}
                    >
                      {category.product_category_description}
                    </p>
                  )}
                </div>

                {/* Arrow */}
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            ))
          ) : (
            <div className="flex justify-center items-center h-40">
              <p className="text-gray-500 text-xs">No categories found</p>
            </div>
          )}
        </div>
      </div>

      {/* Product Search Overlay */}
      <ProductSearchOverlay
        isOpen={isProductSearchOpen}
        onClose={() => setIsProductSearchOpen(false)}
      />

     {showViewBucket && !isProductSearchOpen && (
  <ViewBucket
    ref={bucketRef}
    bucketProducts={bucketProducts}
    imageUrl={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}
  />
)}

    </div>
  );
};

export default ProductCategories;
